/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// React
import React from "react";

// Zaim engineering components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { IconButton, Tooltip } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import UndoIcon from "@mui/icons-material/Undo";
import { formatRefId, formatDate } from "../../../utils/format";

export default function buildOrderTable(
  data,
  onEdit,
  onDownloadInvoice,
  onRevert,
  canView = true,
  canUpdate = true,
  canDownloadInvoice = true,
  canRevert = false
) {
  const Client = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "Order ID", accessor: "refId", align: "left" },
    { Header: "Client", accessor: "client", width: "35%", align: "left" },
    { Header: "quoted By", accessor: "quotedBy", align: "center" },
    { Header: "created", accessor: "createdAt", align: "center" },
    { Header: "grand total", accessor: "grandTotal", align: "center" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    const statusColor = item.status === "Delivered" ? "success" : "warning";
    const isDelivered = item.status === "Delivered";
    return {
      refId: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatRefId(item)}
        </MDTypography>
      ),
      client: <Client name={item.customer.name} email={item.customer.email} />,
      quotedBy: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.user.name}
        </MDTypography>
      ),
      createdAt: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatDate(item.createdAt)}
        </MDTypography>
      ),
      grandTotal: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          ₹{Math.round(item.grandTotal)}
        </MDTypography>
      ),
      status: (
        <MDBox ml={-1}>
          <MDBadge badgeContent={item.status} color={statusColor} variant="gradient" size="sm" />
        </MDBox>
      ),
      action: (
        <MDBox display="flex" justifyContent="center" alignItems="center">
          {(isDelivered ? canView : canUpdate) && (
            <Tooltip title={isDelivered ? "View" : "Edit"}>
              <IconButton
                color="info"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  onEdit(item.id);
                }}
              >
                {isDelivered ? (
                  <VisibilityIcon fontSize="small" />
                ) : (
                  <EditNoteIcon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
          )}
          {canDownloadInvoice && (
            <Tooltip title="Download Invoice">
              <IconButton
                color="info"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  onDownloadInvoice(item.id);
                }}
              >
                <DownloadIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {/* Only orders that are not yet completed can go back to being a quotation. */}
          {canRevert && !isDelivered && (
            <Tooltip title="Revert to Quotation">
              <IconButton
                color="warning"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  onRevert(item.id);
                }}
              >
                <UndoIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </MDBox>
      ),
    };
  });

  return { columns, rows };
}
